/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S6_Li2_CInputs */

const tr_mesafeli_s6_li2_c = /** @type {(inputs: Mesafeli_S6_Li2_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adresine yazılı bildirim göndererek kaydettirebilir; ödenmiş dönemin sonuna kadar erişim devam eder.`)
};

const en_mesafeli_s6_li2_c = /** @type {(inputs: Mesafeli_S6_Li2_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`with the same effect; access continues until the end of the paid term.`)
};

const de_mesafeli_s6_li2_c = /** @type {(inputs: Mesafeli_S6_Li2_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mit derselben Wirkung; der Zugang bleibt bis zum Ende der bezahlten Laufzeit bestehen.`)
};

const ru_mesafeli_s6_li2_c = /** @type {(inputs: Mesafeli_S6_Li2_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`с тем же результатом; доступ сохраняется до конца оплаченного срока.`)
};

/**
* | output |
* | --- |
* | "with the same effect; access continues until the end of the paid term." |
*
* @param {Mesafeli_S6_Li2_CInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s6_li2_c = /** @type {((inputs?: Mesafeli_S6_Li2_CInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S6_Li2_CInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s6_li2_c(inputs)
	if (locale === "de") return de_mesafeli_s6_li2_c(inputs)
	if (locale === "ru") return ru_mesafeli_s6_li2_c(inputs)
	return tr_mesafeli_s6_li2_c(inputs)
});